import API from '../../services/API'
import { SearchHistory } from '@/types/search/SearchHistory.type'

export async function loadResults(ctx: any, params: any) {
    const type = params.type
    try {
        ctx.commit('SET_LOADING_RESULTS', { type: type, loading: true })

        const currentList = ctx.state.lists[type]
        const response = await API.searchAll(
            type,
            ctx.state.searchText,
            currentList.currentPage,
            currentList.maxPerPage
        )
        ctx.commit('ADD_LIST_RESULTS', { type: type, ...response })
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING_RESULTS', { type: type, loading: false })
        ctx.commit('SET_FIRST_LOADED_RESULTS', { type: type })
    }
}

export async function loadAllResults(ctx: any) {
    if (ctx.state.searchText !== '') {
        const types = ctx.getters.getAllTypes
        for (const type of types) {
            ctx.commit('CLEAR_LIST_RESULTS', { type: type })
            ctx.dispatch('loadResults', { type: type })
        }

        await API.putSearchHistory({ searchText: ctx.state.searchText })
        ctx.dispatch('loadSearchHistory')
    }
}

export async function loadSearchHistory(ctx: any) {
    try {
        ctx.commit('SET_SEARCH_HISTORY_LOADING', true)

        const response = await API.getSearchHistory()
        ctx.commit('SET_SEARCH_HISTORY_RESULTS', response)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_SEARCH_HISTORY_LOADING', false)
    }
}

export async function deleteSearchHistory(ctx: any, searchHistory: SearchHistory) {
    try {
        API.deleteSearchHistory(searchHistory)
        const results = ctx.state.history.results.filter((history: any) => {
            return history.id !== searchHistory.id
        })
        ctx.commit('SET_SEARCH_HISTORY_RESULTS', results)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_SEARCH_HISTORY_LOADING', false)
    }
}
